<script setup>
// The data-environment-logo wrapper around the mark is the hook the
// non-production environment tag centers itself above
// (partials/environment-badge.blade.php); it is inert on production.
defineProps({
    // "dark" → GIFT in navy (light backgrounds); "inverse" → GIFT in white (dark backgrounds)
    variant: {
        type: String,
        default: "dark",
    },
    // Smaller lockup (41px mark / 26px wordmark) for tight chrome such as the
    // mobile nav drawer; the default is the 57px / 34px header size.
    compact: {
        type: Boolean,
        default: false,
    },
});
</script>

<template>
    <span class="flex items-center gap-3">
        <span class="shrink-0" data-environment-logo>
            <img
                :src="asset('images/brand/logo-mark.png')"
                alt="Gift Hero"
                class="block object-contain"
                :class="compact ? 'size-[41px]' : 'size-[57px]'"
            />
        </span>
        <span
            class="whitespace-nowrap font-brand font-bold uppercase leading-none tracking-tight"
            :class="compact ? 'text-[26px]' : 'text-[34px]'"
        >
            <span
                class="transition-colors delay-100 duration-200"
                :class="
                    variant === 'inverse' ? 'text-white' : 'text-brand-navy'
                "
            >
                Gift</span
            ><span class="text-brand-red"> Hero</span>
        </span>
    </span>
</template>
